export async function indexShippingAccountsUseCase(shippingAccountRepostitory) {
    const result = await shippingAccountRepostitory.index();

    result.data.data.forEach( x => {
        const entity = new shippingAccountRepostitory.model(x.attributes);

        if (!entity.isValid()) {
            throw new Error("Resultado invalido");
        }
    })
    
    return result;
}